

























import {reactive, ref, defineComponent} from '@vue/composition-api'

export default defineComponent({
  setup(_props, context) {
    const dialogOpen = ref(false)
    const state = reactive({
      dialogOpen: false,
      saveLocally: true,
    })

    const closeDialog = () => {
      state.dialogOpen = false
    }

    const toggleDialog = () => {
      dialogOpen.value = !dialogOpen.value
    }

    const doSave = () => {
      context.emit('saveGltf', {saveLocally: state.saveLocally})
      closeDialog()
    }
    return {state, closeDialog, toggleDialog, doSave}
  }

})
